import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { toast } from "react-toastify";
import { __API_URL__ } from "../SERVER_URL";

const deleteTrialDocument = async ({ documentId }) => {
  const token = localStorage.getItem("token");

  const res = await axios.delete(`${__API_URL__}/api/photos/documents/${documentId}/`, {
    headers: { Authorization: `Token ${token}` },
  });
  return res.data;
};

const useDeleteTrialDocumentMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteTrialDocument,
    onSuccess: (_data, { trialId }) => {
      queryClient.invalidateQueries({ queryKey: ["trial-documents", trialId] });
      toast.success("Document deleted successfully");
    },
    onError: (error) => {
      toast.error(error.message || "Failed to delete document");
    },
  });
};

export default useDeleteTrialDocumentMutation;
